import { useEffect, useRef, useState } from "react";
import CRUDTable from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTable";
import CRUDTableHeader from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDTableHeader";
import CRUDth from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableHeader/CRUDth/CRUDth";
import ShortTextCell from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell";
import CRUDTableRow from "../../../../Partials/Layouts/CRUDs/CRUDTable/CRUDTableRow/CRUDTableRow";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import { PRODUCTS_API, PRODUCTSIZE_API, CHANGED_INVENTORIES_API, PRODUCT_COST } from "../../../../../Utilities/APIs/APIs";
import CRUDButton from "../../../../Partials/Layouts/CRUDs/CRUDButtons/CRUDButton";
import { useNavigate } from "react-router-dom";
import { RiImage2Line, RiSearchLine } from "react-icons/ri";
import Pagination from "../../../../Partials/Elements/pagination/Pagination";

function ProductReports() {
  const [products, setProducts] = useState([]);
  const [productSizes, setProductSizes] = useState({});
  const [givenSizes, setGivenSizes] = useState({});
  const screenHeaerRef = useRef();
  const [screenHeaderHeight, setScreenHeaderHeight] = useState(0);

  useEffect(() => {
    let screenHeaderHeight = screenHeaerRef.current.clientHeight;
    setScreenHeaderHeight(screenHeaderHeight);
  }, [screenHeaerRef]);

  const [toggleFetch, setToggleFetch] = useState(false);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [limit] = useState(40);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [unitCosts, setUnitCosts] = useState({});
  const [totalGivenQuantities, setTotalGivenQuantities] = useState({});
  const [sellPercentages, setSellPercentages] = useState({});
  
  const axiosInstance = useAxiosInstance();
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchAndSetProducts() {
      const res = await axiosInstance.get(
        `${PRODUCTS_API}?search=${search}&page=${currentPage}&limit=${limit}`
      );
      setProducts(res?.data?.products);
      setTotalItems(res?.data?.totalItems);
  
      res?.data?.products?.forEach(async (product) => {
        const sizeRes = await axiosInstance.get(
          PRODUCTSIZE_API + "getProductSizesByProduct/" + product._id
        );
        const sizes = sizeRes?.data || [];
        setProductSizes((prevState) => ({
          ...prevState,
          [product._id]: sizes,
        }));
  
        let totalGivenQuantity = 0;
  
        await Promise.all(
          sizes.map(async (size) => {
            const givenSizeRes = await axiosInstance.get(
              CHANGED_INVENTORIES_API + "getChangedInventories/" + size._id
            );
            const inventoryChanges = givenSizeRes?.data || [];
  
            const givenSizeTotal = inventoryChanges.reduce(
              (sum, change) => sum + (change.quantity || 0),
              0
            );
  
            setGivenSizes((prevState) => ({
              ...prevState,
              [size._id]: givenSizeTotal,
            }));
  
            totalGivenQuantity += givenSizeTotal;
          })
        );
  
        // Correcting sell percentage calculation
        const soldQuantity = totalGivenQuantity - product.quantity;
        const sellPercentage =
          totalGivenQuantity > 0
            ? ((soldQuantity / totalGivenQuantity) * 100).toFixed(0) + "%"
            : "0%";
  
        setTotalGivenQuantities((prevState) => ({
          ...prevState,
          [product._id]: totalGivenQuantity,
        }));
  
        setSellPercentages((prevState) => ({
          ...prevState,
          [product._id]: sellPercentage,
        }));
  
        const costRes = await axiosInstance.get(
          PRODUCT_COST + "getManageCostByProduct/" + product._id
        );
        const unitCost =
          costRes?.data?.length > 0 ? costRes.data[0].unitCost : 0;
  
        setUnitCosts((prevState) => ({
          ...prevState,
          [product._id]: unitCost,
        }));
      });
    }
  
    fetchAndSetProducts();
  }, [toggleFetch, axiosInstance, search, currentPage]);  
  
  

  const handleSearchInput = (value) => {
    const timeoutId = setTimeout(() => {
      setSearch(value);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  };

  return (
    <>
      <div className="screen_header" ref={screenHeaerRef}>
        <h1 className="screen_heading">Products ({totalItems} in total)</h1>
        <div>
          <input
            value={searchInput}
            onChange={(e) => {
              handleSearchInput(e.target.value);
              setSearchInput(e.target.value);
            }}
            className="input_field"
            placeholder="Search"
            style={{ width: "400px" }}
          />
          <RiSearchLine
            style={{
              width: "30px",
              height: "30px",
              marginLeft: "-50px",
              color: "var(--white-2)",
            }}
          />
        </div>
      </div>
      <CRUDTable screenHeaderHeight={screenHeaderHeight}>
        <CRUDTableHeader>
          <CRUDth th="SKU" />
          <CRUDth th="Name" />
          <CRUDth th="Status" />
          <CRUDth th="Unit Cost" />
          <CRUDth th="Old Price" />
          <CRUDth th="New Price" />
          <CRUDth th="Gender" />
          <CRUDth th="Discount" />
          <CRUDth th="Curnt Stock" />
          <CRUDth th="Given Stock" />
          <CRUDth th="Sold Qnty" />
          <CRUDth th="Current Qnty" />
          <CRUDth th="Total Gvn Qnty" />
          <CRUDth th="Sell Percentage" />
        </CRUDTableHeader>
        <tbody>
          {products?.length > 0 &&
            products.map((product) => (
              <CRUDTableRow key={product._id}>
                <ShortTextCell text={product.squId} />
                <ShortTextCell text={product.name} />

                {/* Product Status */}
                <ShortTextCell
                  text={product.isVisible ? "Active" : "Inactive"}
                />

                <ShortTextCell
                  text={unitCosts[product._id] || product.unitCost}
                />
                <ShortTextCell text={product.price} />
                <ShortTextCell text={product.currentPrice} />
                <ShortTextCell text={product.gender} />

                {product.discount ? (
                  <ShortTextCell text={`${product.discount.percentage}%`} />
                ) : (
                  <ShortTextCell text="0%" />
                )}

                {/* Product sizes and available quantities */}
                <td>
                  {productSizes[product._id]?.map((size) => (
                    <div key={size._id}>
                      <span>
                        {size.size.name} : {size.quantity}
                      </span>
                    </div>
                  ))}
                </td>

                {/* Given sizes */}
                <td>
                  {productSizes[product._id]?.map((size) => (
                    <div key={size._id}>
                      <span>
                        {size.size.name} : {givenSizes[size._id] || 0}
                      </span>
                    </div>
                  ))}
                </td>

                {/* Remaining quantities */}
                <td>
                  {productSizes[product._id]?.map((size) => (
                    <div key={size._id}>
                      <span>
                        {size.size.name} :{" "}
                        {Math.max(
                          (givenSizes[size._id] || 0) -
                            (size.quantity || 0),
                          0
                        )}
                      </span>
                    </div>
                  ))}
                </td>

                <ShortTextCell text={product.quantity} />

                {/* Total Given Quantity */}
                <ShortTextCell
                  text={totalGivenQuantities[product._id] || "0"}
                />

                {/* Sell Percentage */}
                <ShortTextCell
                  text={sellPercentages[product._id] || "0%"}
                />
              </CRUDTableRow>
            ))}
        </tbody>
        <Pagination
          items={products}
          totalItems={totalItems}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        />
      </CRUDTable>
    </>
  );
}

export default ProductReports;
